import * as React from "react";
import Accordion from "react-bootstrap/Accordion";

import { Link, useNavigate, useParams } from "react-router-dom";

import { RiArrowLeftLine, RiCheckLine } from "react-icons/ri";

import Button from "../../../Components/Button";
import Paper from "../../../Components/Paper";
import Checkbox from "../../../Components/Checkbox";
import Modal from "../../../Components/Modal";

import axiosInstance from "../../../Api/Axios";
import { useToast } from "../../../Context/ToastContext";
import { useLoader } from "../../../Context/LoaderContext";

import { addSeparateur } from "../../../Functions/separateur_chiffre";

import "./FinancingRequestStep3.scss";

const initialFormState = {
  declaration_recap: false,
  consentement_rgpd: false,
};

const FinancingRequestStep3 = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");
  const [dataRecap, setDataRecap] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (val, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  React.useEffect(() => {
    setIsLoading(true);

    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation/${id}`)
      .then(async (response) => {
        setIsLoading(false);
        const data = response.data.data || {};
        setDataRecap(data);
      })
      .catch((error) => {
        setIsLoading(false);
        addToast({
          variant: "danger",
          message: error.response.data.data.message,
        });
      });
  }, [addToast, id, setIsLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/financing-request/update`, {
        declaration_recap: valRegister.declaration_recap,
        consentement_rgpd: valRegister.consentement_rgpd,
        step: "resume",
        simulation_id: id,
      })
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate(`/financing-request/confirm-request/${id}`);
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  const CheckboxLabel = ({ clientName }) => (
    <span>
      Je soussigné(e) <b>{clientName}</b>, certifie que les informations
      fournies dans ce formulaire sont exactes et complètes. Je m'engage à
      informer immédiatement l'institution financière de toute modification
      concernant les informations fournies.
    </span>
  );
  const CheckboxLabelRgpb = () => (
    <span>
      J'autorise ce site à conserver mes données personnelles transmises via ce
      formulaire.
    </span>
  );

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <>
      <Link
        to={`/financing-request/documents-to-attach/${id}`}
        className="link-back-financing"
      >
        <RiArrowLeftLine />
      </Link>
      <h1>Récapitulatif</h1>
      <p>
        Revoyez toutes les informations fournies dans ce formulaire pour vous
        assurer de leur exactitude et de leur exhaustivité.
      </p>
      <Paper>
        <div className="wrap-steps-sidebar-not-connected">
          <div className="steps-sidebar-not-connected visited">
            1. Informations Clients
            <RiCheckLine />
          </div>

          <div className="steps-sidebar-not-connected visited">
            2. Documents à Joindre
            <RiCheckLine />
          </div>
          <div className="steps-sidebar-not-connected active">
            3. Récapitulatif
          </div>
        </div>

        <div className="step-simulateur">
          <form className="register-form" onSubmit={handleSubmit} noValidate>
            <div className="step-financing-request custom-accordion mb-16">
              <Accordion defaultActiveKey="0" alwaysOpen>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Détails du Projet de Leasing
                  </Accordion.Header>
                  <Accordion.Body>
                    <table className="table custom-table">
                      <tbody>
                        <tr>
                          <td>Montant</td>
                          <td>
                            {addSeparateur(dataRecap?.simulation?.amount) ||
                              "-"}{" "}
                            TND
                          </td>
                        </tr>
                        <tr>
                          <td>Autofinancement</td>
                          <td>
                            {addSeparateur(
                              dataRecap?.simulation?.self_financing
                            ) || "-"}{" "}
                            TND
                          </td>
                        </tr>
                        <tr>
                          <td>Durée</td>
                          <td className="orange">
                            {dataRecap?.simulation?.duration || "-"} mois
                          </td>
                        </tr>

                        <tr>
                          <td>Type de bien à financer</td>
                          <td className="text-capitalize">
                            {dataRecap?.simulation?.product_name || "-"}
                          </td>
                        </tr>

                        <tr>
                          <td>Description</td>
                          <td>{dataRecap?.simulation?.description || "-"}</td>
                        </tr>

                        <tr>
                          <td colSpan={2} className="last-child-table">
                            <div className="titlte-montant">
                              Montant du loyer par mois
                            </div>
                            <div className="value-montant">
                              {addSeparateur(
                                dataRecap?.simulation?.result_amount
                              ) || "-"}
                              TND
                            </div>
                            <p>Le taux appliqué au niveau du site est à titre indicatif</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Informations sur le Demandeur
                  </Accordion.Header>
                  <Accordion.Body>
                    <table className="table custom-table">
                      <tbody>
                        {dataRecap?.client_name && (
                          <tr>
                            <td>Nom</td>
                            <td>{dataRecap.client_name || "-"}</td>
                          </tr>
                        )}
                        {dataRecap?.tax_id && (
                          <tr>
                            <td>Matricule fiscal</td>
                            <td>{dataRecap.tax_id || "-"}</td>
                          </tr>
                        )}
                        {dataRecap?.created_at && (
                          <tr>
                            <td>Date de création</td>
                            <td>{dataRecap.created_at || "-"}</td>
                          </tr>
                        )}
                        {dataRecap?.request_type && (
                          <tr>
                            <td>Secteur d'Activité</td>
                            <td>{dataRecap.activity_sector || "-"}</td>
                          </tr>
                        )}
                        {dataRecap?.email && (
                          <tr>
                            <td>Email</td>
                            <td>{dataRecap.email || "-"}</td>
                          </tr>
                        )}
                        {dataRecap?.phone && (
                          <tr>
                            <td>Téléphone</td>
                            <td>{dataRecap.phone || "-"}</td>
                          </tr>
                        )}
                        {dataRecap.fax && (
                          <tr>
                            <td>Fax</td>
                            <td>{dataRecap.fax || "-"}</td>
                          </tr>
                        )}

                        <tr>
                          <td>Adresse</td>
                          <td>
                            {(dataRecap.address && dataRecap.address) || "-"}
                            <br />
                            {(dataRecap?.postal_code && dataRecap.postal_code) +
                              " - " +
                              dataRecap.city}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Documents à Joindre</Accordion.Header>
                  <Accordion.Body>
                    <ul className="list-accordion">
                      {dataRecap?.documents?.map((doc) => {
                        return <li key={doc.id}>{doc.title}</li>;
                      })}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>

              <h2 className="title_form mt-40">Déclaration</h2>

              <Checkbox
                label={<CheckboxLabel clientName={dataRecap?.client_name} />}
                id="declaration_recap"
                name="declaration_recap"
                value="declaration_recap"
                onChange={(e) =>
                  handleChangeField(e.target.checked, "declaration_recap")
                }
                checked={valRegister.declaration_recap}
              />
              <Checkbox
                label={<CheckboxLabelRgpb />}
                id="consentement_rgpd"
                name="consentement_rgpd"
                value="consentement_rgpd"
                onChange={(e) =>
                  handleChangeField(e.target.checked, "consentement_rgpd")
                }
                checked={valRegister.consentement_rgpd}
              />
              <p className="link-text-rgpd">
                Voir notre{" "}
                <b onClick={handleOpenModal}>
                  politique de gestion des données personnelles
                </b>
              </p>
            </div>
            <div className="wrap-btn-action-request">
              <Button variant="white" size="lg">
                <Link
                  to={`/financing-request/documents-to-attach/${id}`}
                  className="link-back"
                >
                  <RiArrowLeftLine />
                  Précedent
                </Link>
              </Button>
              <Button
                type="submit"
                disabled={
                  !valRegister.declaration_recap ||
                  !valRegister.consentement_rgpd
                }
              >
                Soumettre la Demande
              </Button>
            </div>

            <Modal
              isOpen={openModal}
              onClose={handleCloseModal}
              withCloseButton
              title="Protection des données à caractère personnel"
              className="custom-modal-simulation"
              size="lg"
            >
              <div className="content-rgpd-modal">
                <p className="bold">Information de la personne concernée</p>
                <p>
                  Dans le cadre de sa relation avec ses clients, Attijari
                  Leasing en sa qualité de responsable de traitement est engagée
                  à recueillir et traiter vos données à caractère personnel
                  conformément à la loi organique N°2004-63 du 27 juillet 2004
                  portant sur la protection des données à caractère personnel.
                </p>

                <br />

                <p>
                  Le traitement de vos données répond aux finalités suivantes :
                </p>

                <ul>
                  <li>
                    Exécution d’un contrat ou de mesures précontractuelles : La
                    fourniture d’informations précontractuelles relatives aux
                    produits et services ; La fourniture de produits et
                    services;La gestion des contrats.
                  </li>
                  <li>
                    La conformité aux obligations légales et réglementaires :
                    Partage des données collectées à des fins de connaissance du
                    client (KYC) ; Gestion consolidée des risques ; Surveillance
                    consolidée du Contrôle Interne ; Lutte contre le blanchiment
                    de capitaux et le financement du terrorisme, respect de
                    sanctions internationales, d’embargos ; Respect des
                    obligations déclaratives
                  </li>
                  <li>
                    Les intérêts légitimes : Lutte contre la fraude ;
                    Sécurisation du réseau et des systèmes d’information ;
                    Conduite des initiatives de développement à des fins
                    commerciales, de communication et de marketing ;
                  </li>
                </ul>

                <p>
                  Vos données personnelles sont susceptibles d’être communiquées
                  notamment aux sociétés du Groupe Attijari bank ; Aux
                  sous-traitants, mandataires, courtiers ou autres
                  intermédiaires, partenaires ou prestataires de service ; Aux
                  autorités administratives ou judiciaires habilitées ou plus
                  généralement à tout tiers autorisé (avocats, commissaires aux
                  comptes…), pour satisfaire les obligations légales ou
                  réglementaires auxquelles le Groupe est soumis. Vos données
                  sont conservées pendant les délais réglementaires
                </p>

                <p>
                  Vous bénéficiez des droits d’accès, de rectification, de
                  limitation du traitement de vos données ainsi que du droit
                  d’opposition sauf dans les cas où le traitement répond à une
                  obligation légale- au traitement de vos données à caractère
                  personnel. Vous pouvez exercer ces droits en :
                </p>

                <ul>
                  <li>
                    Adressant votre demande accompagnée d’une copie de votre CIN
                    à l’adresse :{" "}
                    <b>
                      <u>service.client@attijarileasing.com.tn</u>
                    </b>
                  </li>
                  <li>
                    Appelant au <b>70 136 436</b>
                  </li>
                </ul>

                <p>
                  Si vous estimez, après nous avoir contactés, que vos droits ne
                  sont pas respectés, vous pouvez adresser une réclamation à
                  L’Instance Nationale de la Protection des Données Personnelles
                </p>
                <p className="bold">Déclaration de la personne concernée</p>

                <p>
                  Je reconnais formellement avoir pris connaissance des
                  conditions d’utilisation de mes données personnelles, et
                  auxquelles je déclare adhérer pleinement et sans aucune
                  réserve. En vertu des présentes :
                </p>

                <ul>
                  <li>Je déclare avoir lu ce document</li>
                  <li>
                    J’accepte qu’Attijari Leasing collecte les données
                    personnelles me concernant
                  </li>
                  <li>
                    J’autorise Attijari Leasing à traiter mes informations
                    nominatives, à les conserver en mémoire informatique, à les
                    utiliser ainsi qu’à les communiquer à ses partenaires pour
                    les finalités listées
                  </li>
                  <li>
                    J’accepte de recevoir des informations et des offres
                    commerciales sur mes coordonnées (Adresse, email, téléphone)
                    de la part d’Attijari Leasing et ses partenaires,
                  </li>
                  <li>
                    Je déclare que les informations nominatives me concernant et
                    déclarées en vertu du présent sont exactes et précises
                  </li>
                </ul>
                <p>
                  J’autorise Attijari Leasing de transférer mes données à ses
                  partenaires, au Groupe Atijariwafa bank, ou plus généralement
                  à tout tiers autorisé afin de réaliser les finalités listées
                </p>
              </div>
            </Modal>
          </form>
        </div>
      </Paper>
    </>
  );
};

export default FinancingRequestStep3;
